export enum RegisteredKeys {
  ENTER = "Enter",
  DOWN = "ArrowDown",
  UP = "ArrowUp",
}
